import SuperJSON from "superjson";
import Id from "../types/Id";

export default class FormId extends Id<"form"> {}

SuperJSON.registerClass(FormId, { identifier: "FormId" });
